import { QueryResult } from 'react-query';
// eslint-disable-next-line import/no-cycle
import { Kunde } from './kunde';
import { callApi, Controller, useApi } from './useApi';
import { defaultSmDate } from '../utils/formatter';

export interface Ansprechpartner {
    nr: number;
    kNr: number;
    anrede: string;
    titel: string;
    name: string;
    position: string;
    abteilung: string;
    telefon: string;
    mobil: string;
    fax: string;
    mail: string;
    gebDat: string;
    sprache: string;
    briefanrede: string;
    eRechnung: boolean;
    userKz: string;
    archiv: boolean;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
    kunde?: Kunde;
}

export const defaultAnsprechpartner: Ansprechpartner = {
    kNr: 0,
    nr: 0,
    anrede: '',
    titel: '',
    name: '',
    position: '',
    abteilung: '',
    telefon: '',
    mobil: '',
    fax: '',
    mail: '',
    gebDat: defaultSmDate,
    sprache: 'D',
    briefanrede: '',
    eRechnung: false,
    userKz: '',
    archiv: false,
};

export interface AnsprechpartnerFilter {
    nr?: number;
    kNr?: number;
    includeArchiv?: boolean;
    withKunde?: boolean;
    maxRows?: number;
}

export function useAnsprechpartnerList(
    filter: AnsprechpartnerFilter,
    enabled = true,
    allowCaching = false,
): QueryResult<Ansprechpartner[]> {
    return useApi<Ansprechpartner[]>(Controller.ansprechpartner + '/list', { filter }, { enabled, allowCaching });
}

export async function addAnsprechpartner(ansprechpartner: Ansprechpartner): Promise<void> {
    return callApi<void>(Controller.ansprechpartner + '/add', { ansprechpartner });
}

export async function updateAnsprechpartner(ansprechpartner: Ansprechpartner): Promise<void> {
    return callApi<void>(Controller.ansprechpartner + '/update', { ansprechpartner });
}
